<template>
    <div class="staff-description">
        <el-tabs v-model="activeName" type="border-card">
            <el-tab-pane :label="$lange == 'en' ? 'Personnel approval' : '人员审批'" name="staff">
                <div class="task">
            <div class="task-top">
                <template v-if="$lange == 'en'">
                    <p>Customer: {{taskData.customerName}}</p>
                    <p>Product Line: {{taskData.productLine}}</p>
                    <p>Type: {{["Installing", "After-sale service"][taskData.type]}}</p>
                    <p>Service cycle: {{moment(taskData.startTime).format("YYYY-MM-DD")}} 至 {{moment(taskData.endTime).format("YYYY-MM-DD")}}</p>
                </template>
                <template v-else>
                    <p>客户: {{taskData.customerName}}</p>
                    <p>产品线: {{taskData.productLine}}</p>
                    <p>项目类型: {{["安装项目", "售后服务"][taskData.type]}}</p>
                    <p>服务周期: {{moment(taskData.startTime).format("YYYY-MM-DD")}} 至 {{moment(taskData.endTime).format("YYYY-MM-DD")}}</p>
                </template>

            </div>
            <div class="content">
                <div class="task-title">
                    <p class="jump-url" @click="goDetail">{{$lange == 'en' ? 'Project ID' : '项目ID'}}: {{taskData.objId || "---"}}</p>
                    <p>{{$lange == 'en' ? 'Project Manager' : '项目经理'}}: {{taskData.projectManager || "---"}}</p>
                    <p>{{$lange == 'en' ? 'Team' : '团队成员'}}: {{taskData.member || "---"}}</p>
                    <div>
                        <span style="display: inline-block; min-width: 60px; margin-right: 20px;">{{$lange == 'en' ? 'Status' : '状态'}}: {{projectStatus[taskData.status].title}}</span>
                        <el-button size="mini" type="primary" @click="trialAll" v-if="isTrial"> {{$lange == 'en' ? 'All approved' : '全部审核通过'}} </el-button>
                    </div>
                </div>
                <el-row style="margin-top: 20px;">
                    <el-col :span="12">
                        <div class="table-box not-padding">
                            <cc-table
                                    :config="tableConfig"
                                    :dataArr="ganttData"
                                    :loadData="false"
                                    :stripe="false"
                            >
                        </cc-table>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="ganntt-box" v-if="ganttData.length > 0">
                            <Gantt :isMerge="true" :utasks="ganttData"></Gantt>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
            </el-tab-pane>
        </el-tabs>
        <el-dialog
                :title="$lange == 'en' ? 'Reasons for returning' : '退回原因'"
                :visible.sync="backMsgDialog"
                width="30%"
        >
            <el-input v-model="backMsg" size="mini" :placeholder="$lange == 'en' ? 'Please Input Reasons' : '请输入退回原因'" type="textarea" cow="4" ></el-input>
            <div style="margin-top: 20px; justify-content: flex-end;" class="flex-between">
                <el-button type="primary" size="mini" @click="backSuccess">{{$lange == 'en' ? 'Submit' : '提交'}}</el-button>
            </div>
        </el-dialog>
        <div class="back-btn" @click="backBtn">
            <el-button type="danger" size="mini" icon="el-icon-circle-close"></el-button>
        </div>
    </div>
</template>

<script>
    import Gantt from "../../components/Gantt"
    import moment from "moment"
    export default {
        name: "StaffTrial",
        components:{
            Gantt
        },
        data(){
            return {
                moment: moment,
                activeName: "staff",
                projectStatus: [],
                ganttTableConfig: {},
                staffId: false,
                tableConfig: {
                    rowClassName: ({row, rowIndex})=>{
                        if(row.expectedWorkHour !== undefined){
                            return 'info-row'
                        } else {
                            return ''
                        }
                    },
                    height: "150px",
                    columns: [
                        {
                            prop: "projectTasksName",
                            lable: this.$lange == 'en' ? 'Task Name' : "任务名称",
                            type: "input",
                        },
                        {
                            prop: "memberName",
                            lable: this.$lange == 'en' ? 'Team' : "团队成员",
                            type: "input",
                            render: function(row){
                                let res = `${row.memberName}`;
                                if(row.isLeader === 1){
                                    res = `(组) ${row.memberName}`
                                }
                                return res;
                            }
                        },
                        {
                            prop: "startTime",
                            lable: this.$lange == 'en' ? 'End Time' : "开始",
                            type: "date",
                            render: row => {
                                return moment(row.startTime).format("YYYY-MM-DD")
                            }
                        },
                        {
                            prop: "endTime",
                            lable: this.$lange == 'en' ? '' : "预计结束",
                            type: "date",
                            render: row => {
                                return moment(row.endTime).format("YYYY-MM-DD")
                            }
                        },
                        // { //产品提了优化, 去掉
                        //     prop: "expectedWorkHour",
                        //     lable: "预计总工时",
                        //     type: "input",
                        // },
                        {
                            prop: "isAudit",
                            lable: this.$lange == 'en' ? '' : "状态",
                            type: "tag",
                            options: [
                                {tagType: "warning", text: "待审核"},
                                {tagType: "success", text: "已通过"},
                                {tagType: "danger", text: "未通过"},
                                {tagType: "info", text: "未提交"},
                            ]
                        },

                    ],
                    buttons: [
                        {
                            name: "通过",
                            check: row => {
                                let res = true;
                                console.log(this.isTrial, row.isAudit, "row.isAudit")
                                if(this.isTrial != true || row.isAudit !== 0){
                                    res = false;
                                }
                                return res;
                                // return this.isTrial === true && row.isAudit === 0 || row.isAudit == "-1";
                            },
                            click: row =>{
                                this.trialOnce(row.id)
                            }
                        },{
                            name: "退回",
                            check: row => {
                                let res = true;
                                if(this.isTrial != true || row.isAudit !== 0){
                                    res = false;
                                }
                                return res;
                                // return this.isTrial === true && row.isAudit === 0 || row.isAudit == "-1";
                            },
                            click: row =>{
                                this.backId = row.id;
                                this.backMsgDialog = true;
                            }
                        },
                        // { //产品提了优化, 去掉
                        //     name: "收展",
                        //     check: row => {
                        //         return row.expectedWorkHour !== undefined
                        //     },
                        //     click: (row,$index) =>{
                        //         if(this.hideChildes.indexOf(row.id) > -1){
                        //             console.log(this.hideChildes)
                        //             for(let i in this.hideChildes){
                        //                 if(this.hideChildes[i] === row.id){
                        //                     this.hideChildes.splice(i,1)
                        //                 }
                        //             }
                        //         }else{
                        //             this.hideChildes.push(row.id);
                        //         }
                        //         this.getGanttData();
                        //     }
                        // },

                    ]
                },
                statusValue: "",
                isTrial: false,
                taskData: {},
                ganttData: [],
                backId: false,
                backMsgDialog: false,
                backMsg: "",
                hideChildes: [],
            }
        },
        methods: {
            goDetail(){
                let path = "/admin/project/description";
                let query = {
                    fasId: this.taskData.objId
                }
                if(this.taskData.type == 1){
                    path = "/admin/order/des";
                    query = {
                        id: this.taskData.objId
                    }
                }
                this.$router.push({
                    path: path,
                    query: query
                })
            },
            backBtn() {
                this.$router.go(-1);
            },
            backSuccess(){
                this.trialOnce(this.backId,2,this.backMsg);
                this.backMsgDialog = false;

            },
            trialOnce(id, isAudit=1, msg = false){
                let data = {
                    isAudit: isAudit,
                    reviewMessage: msg || "",
                    ids: id,
                    projectId: this.taskData.id
                }
                this.ccRequest.do("admin/fsb/personnel/review/batchReview", data, "GET").then(res => {
                    this.$message({
                        type: "success",
                        message: "操作成功"
                    })
                    this.getGanttData();
                })
            },
            trialAll (){
                this.$confirm('此操作会将所有员工都审核通过?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let data = {
                        projectId: this.staffId
                    }

                    this.ccRequest.do("admin/fsb/personnel/review/reviewAll", data, "GET").then(res => {
                        this.$message({
                            type: "success",
                            message: "已通过"
                        })
                        setTimeout(()=>{
                            this.$router.go(-1);
                        })
                    })
                }).catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '已取消'
                    // });
                });

            },
            getCustomerData (){
                let data = {
                    projectId: this.staffId
                }
                this.ccRequest.do("admin/fsb/personnel/review/getInfo", data, "GET").then(res => {
                    this.taskData = res;
                })
            },
            getGanttData(){
                this.ganttData = [];
                let data = {
                    projectId: this.staffId
                }
                this.ccRequest.do("admin/fsb/personnel/review/queryTasks", data, "GET").then(res => {
                    let newData = [];
                    for(let i in res){
                        res[i].value = res[i].projectTasksName;
                        newData.push(res[i]);
                        // console.log(this.hideChildes,"this.hideChildes",this.hideChildes.indexOf(res[i].id)<0);
                        // res[i].isAudit = -1;
                        if(res[i].items && this.hideChildes.indexOf(res[i].id)<0){
                            for(let j in res[i].items){
                                newData.push(res[i].items[j]);
                            }
                            // delete newData[i].items;
                        }
                    }
                    console.log(newData, "new Data");
                    this.ganttData = newData;
                })
            },
            getProjectStatus(){
                this.ccRequest.do("admin/dict/pageTree", {code: "projectStatus"}, "GET").then(res => {
                    this.projectStatus = res.rows[0].children;
                })
            },
            getData(){
                this.getCustomerData();
                this.getGanttData();
                this.getProjectStatus();
            },
            checkLanguage() {
                if(this.$lange=='en'){

                }

            }
        },
        mounted(){
            if(!this.$route.query.id){
                return this.$router.go(-1);
            }
            this.staffId = this.$route.query.id;
            if(this.$route.query.isTrial){
                this.isTrial = true;
            }
            this.checkLanguage();
            this.getData();

        }
    }
</script>
<style lang="scss">
    .staff-description{
        .el-table__row th,.el-table__row td{
            /*padding: 12px 0 !important;*/
            height: 41px !important;
        }
    }
</style>
<style scoped lang="scss">
    .staff-description{
        .task{
            background: #ffffff;
            padding: 20px;
            box-sizing: border-box;
            .task-top{
                background: #ebeef5;
                padding: 5px 15px;
                display: flex;
                p{
                    margin-right: 55px;
                    font-size: 14px;
                }
            }
            .content{
                margin-top: 35px;
                .task-title{
                    display: flex;
                    align-items: center;
                    >.jump-url{
                        text-decoration: underline;
                        cursor: pointer;
                    }
                    >*{
                        margin-right: 20px;
                    }
                    >div{
                        margin-left: 25px;
                    }
                }
                .table-box{
                }
            }
            .btn-group{
                border-bottom: 1px solid #e4e4e4;
                padding: 20px;
                &.flex-between{
                    justify-content: center;
                }
            }
        }
        .ganntt-box{
        }
    }
</style>
